module.exports = __webpack_public_path__ + "static/media/CloseYellow.1e07362d.svg";